import IPortMonitorsExportRequest from 'features/port/model/PortMonitor/IPortMonitorsExportRequest';
import {stringToBoolean} from 'shared/lib/filterHelper';

import type {IPortMonitorFiltersForm} from '../model/PortMonitor/IPortMonitorFiltersForm';

export function buildPortMonitorsExportRequest(
    {name, ip, port, status, ok, tags, orderBy}: IPortMonitorFiltersForm,
): IPortMonitorsExportRequest {
    const data: IPortMonitorsExportRequest = {};

    if (name) {
        data.name = name;
    }

    if (ip) {
        data.ip = ip;
    }

    if (port) {
        data.port = Number(port);
    }

    if (status) {
        data.status = status;
    }

    if (ok !== null && ok !== undefined) {
        data.ok = stringToBoolean(ok);
    }

    if (tags && tags.length > 0) {
        data.tags = tags;
    }

    if (orderBy?.field) {
        data.order_by = orderBy;
    }

    return data;
}
